<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="flex-none px-2">
      <h5 class="text-sm font-medium text-gray-600 mb-2">Messages</h5>
    </div>
    <div class="flex-1 lg:h-0">
      <div class="h-full overflow-auto fancy-scrollbar px-2 space-y-4">
        <BaseTabbedSection :tabs="tabs" @change="onTabChange" />
        <component :is="currentTab.component" :contact-request="contactRequest" />
      </div>
    </div>
  </div>
</template>

<script>
import { omit } from 'lodash-es';

const tabs = [
  {
    name: 'email_messages',
    label: 'Email',
    permissions: 'read email messages',
    component: () => import('./messages/EmailMessagesTab.vue'),
  },
  {
    name: 'sms_messages',
    label: 'SMS',
    permissions: 'read sms messages',
    component: () => import('./messages/SmsMessageTab.vue'),
  },
];

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentTab: null,
    };
  },
  computed: {
    tabs() {
      return tabs
        .filter((tab) => this.$membershipHasPermissionTo(tab.permissions))
        .map((tab) => omit(tab, ['permissions']));
    },
  },
  watch: {
    tabs: {
      handler(newTabs) {
        if (!newTabs.length) {
          this.currentTab = null;
          return;
        }

        const [firstTab] = newTabs;

        if (firstTab.name === this.currentTab?.name) {
          return;
        }

        this.currentTab = firstTab;
      },
      deep: true,
    },
  },
  created() {
    if (this.tabs.length) {
      const [firstTab] = this.tabs;
      this.currentTab = firstTab;
    }
  },
  methods: {
    onTabChange({ currentTab }) {
      this.currentTab = currentTab;
    },
  },
};
</script>
